import "react-loading-skeleton/dist/skeleton.css";

const OrdersSkeleton: React.FC = () => {
  return (
    <>
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="bg-white rounded-xl p-4 shadow-sm border border-slate-100"
        >
          <div className="animate-pulse space-y-3">
            <div className="h-4 bg-slate-200 rounded w-1/2" />
            <div className="h-3 bg-slate-200 rounded w-3/4" />
            <div className="h-10 bg-slate-200 rounded-lg" />
          </div>
        </div>
      ))}
    </>
  );
};

export default OrdersSkeleton;
